/* src/app/shared/components/popovers/choose-size-popover/choose-size-popover.component.scss */
/*# sourceMappingURL=choose-size-popover.component-BPX4HTKK.css.map */
